// extracted by mini-css-extract-plugin
export default {"cls1":"AuthorHeader-cls1_xCn","cls2":"AuthorHeader-cls2_Cwo AuthorHeader-cls1_xCn"};